import { userService } from "./userService";
import { epmsService } from "./epmsService";
import { dashboard } from "./dashboard";
import { autoProvisioningService } from "./autoProvisioningService";
import { falconService } from "./falconService";
export const service = {
    ...userService,
    ...epmsService,
    ...dashboard,
    ...autoProvisioningService,
    ...falconService
  };
  